import AnimateIn from "@/components/AnimateIn";
import GuatemalaHero from "@/components/guatemala/GuatemalaHero";
import Countdown from "@/components/guatemala/Countdown";
import ParallaxStory from "@/components/guatemala/ParallaxStory";
import SealedEnvelope from "@/components/guatemala/SealedEnvelope";
import {
  guatemalaHeroImage,
  guatemalaPanels,
  guatemalaDropDate,
} from "@/data/mockData";

const HERO_WORDS = [
  "EVERYONE",
  "HAS",
  "THE",
  "WRONG",
  "CONCEPTION",
  "ABOUT",
  "GUATEMALA.",
];

export default function Guatemala() {
  return (
    <div data-testid="guatemala-page" className="bg-black">
      {/* 1. CINEMATIC HERO */}
      <GuatemalaHero
        image={guatemalaHeroImage}
        words={HERO_WORDS}
        subtext="VOL. 1 — INTERNATIONAL DROP"
        ctaHref="#guatemala-signup"
      />

      {/* 2. COUNTDOWN */}
      <section
        className="relative bg-black py-28 md:py-36 px-6 md:px-12 overflow-hidden"
        data-testid="guatemala-countdown"
      >
        <div className="max-w-5xl mx-auto">
          <AnimateIn variant="fade">
            <div className="wc-label text-[10px] md:text-xs gt-red text-center tracking-[0.4em] mb-10">
              UNTIL WE LEAVE
            </div>
          </AnimateIn>
          <AnimateIn variant="fade" delay={100}>
            <Countdown
              target={guatemalaDropDate}
              caption="UNTIL WE LEAVE FOR GUATEMALA — JUNE 18, 2026"
              testid="guatemala-countdown-timer"
            />
          </AnimateIn>
          <AnimateIn variant="fade" delay={300}>
            <p className="text-center text-white/50 text-base md:text-lg mt-14 max-w-xl mx-auto leading-[1.8]">
              We go quiet on the 18th. Vol. 1 drops in July.
            </p>
          </AnimateIn>
        </div>
      </section>

      {/* 3. PARALLAX SCROLL-STORY */}
      <div className="border-t border-white/10">
        <ParallaxStory panels={guatemalaPanels} />
      </div>

      {/* 4. SEALED ENVELOPE WAITLIST */}
      <SealedEnvelope />
    </div>
  );
}
